import { MutationFunction } from '@tanstack/react-query';
import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';

export interface DeleteLoanIncomeParams {
  loanId: string;
  incomeId: string;
}

export interface DeleteLoanIncomeResult {
  success: boolean;
  /** False only when IncomeXpert still holds this income. Absent from an older
   *  API, which is why the caller treats only an explicit `false` as a
   *  divergence. */
  incomeXpertDeleted?: boolean;
}

const deleteLoanIncome: MutationFunction<
  DeleteLoanIncomeResult,
  DeleteLoanIncomeParams
> = async ({ loanId, incomeId }) => {
  if (isMockServices()) {
    return await mock({ success: true, incomeXpertDeleted: true });
  }

  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<DeleteLoanIncomeResult>(
    `/loans/${loanId}/incomes/${incomeId}`,
    { method: 'DELETE' },
  );

  if (response.data) return response.data;
  throw new Error('Failed to delete income');
};

export default deleteLoanIncome;
